import React, {FC} from 'react';
import multimedia from '../../assets/images/icon-page/multimedia.png';


const MultimediaIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Multimedia Icon'}) => {
    return (
        <img
            src={multimedia}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default MultimediaIcon;
